export default __webpack_public_path__ + "static/media/teamArrowDown.97bde9b4.svg";